import {
  HomeIcon,
  BuildingOffice2Icon,
  CurrencyDollarIcon,
  CpuChipIcon,
  ChartBarIcon,
  Cog6ToothIcon,
  MagnifyingGlassIcon,
  DocumentTextIcon,
  ArrowPathIcon,
  ClipboardDocumentListIcon,
  MicrophoneIcon,
} from '@heroicons/react/24/outline';
import type { NavItem } from '@/types/nav';

/** Canonical admin sidebar — updated per Phase 5.1 redesign */
export const adminNavItems: NavItem[] = [
  { id: 'home', label: 'Mission Control', icon: HomeIcon, path: '/admin/home' },
  { id: 'tenants', label: 'Tenants', icon: BuildingOffice2Icon, path: '/admin/tenants' },
  {
    id: 'revenue',
    label: 'Revenue',
    icon: CurrencyDollarIcon,
    path: '/admin/revenue/paynow',
    children: [
      { id: 'paynow', label: 'PayNow', icon: CurrencyDollarIcon, path: '/admin/revenue/paynow' },
      { id: 'plans', label: 'Plans', icon: DocumentTextIcon, path: '/admin/revenue/plans' },
    ],
  },
  {
    id: 'ai-ops',
    label: 'AI Operations',
    icon: CpuChipIcon,
    path: '/admin/ai-ops/quality',
    children: [
      { id: 'quality', label: 'Quality Dashboard', icon: MagnifyingGlassIcon, path: '/admin/ai-ops/quality' },
      { id: 'pipeline', label: 'Scoring Pipeline', icon: ArrowPathIcon, path: '/admin/ai-ops/pipeline' },
      { id: 'review', label: 'Review Queue', icon: ClipboardDocumentListIcon, path: '/admin/ai-ops/review-queue' },
      { id: 'industries', label: 'Industry Configs', icon: DocumentTextIcon, path: '/admin/ai-ops/industry' },
      { id: 'voice', label: 'Voice AI', icon: MicrophoneIcon, path: '/admin/ai-ops/voice', badge: 'Beta' },
    ],
  },
  {
    id: 'monitoring',
    label: 'Monitoring',
    icon: ChartBarIcon,
    path: '/admin/monitoring/activity',
    children: [
      { id: 'activity', label: 'Activity Log', icon: MagnifyingGlassIcon, path: '/admin/monitoring/activity' },
      { id: 'crawl', label: 'Crawl Status', icon: DocumentTextIcon, path: '/admin/monitoring/crawl' },
      { id: 'channels', label: 'Channel Health', icon: ChartBarIcon, path: '/admin/monitoring/channels' },
      { id: 'jobs', label: 'Job Runs', icon: Cog6ToothIcon, path: '/admin/monitoring/jobs' },
    ],
  },
  { id: 'system', label: 'System', icon: Cog6ToothIcon, path: '/admin/system/settings' },
];